(() => {
  if (window.__paintlyMakeYours) return;
  window.__paintlyMakeYours = true;
  if (location.hash === '#paintly-shape') {
    const target = document.getElementById('paintly-shape');
    if (target) {
      let active = true, frame = 0, observer, timer;
      const events = ['pointerdown', 'touchstart', 'wheel', 'keydown'];
      const stop = () => {
        active = false;
        cancelAnimationFrame(frame);
        observer?.disconnect();
        clearTimeout(timer);
        window.removeEventListener('load', align);
        events.forEach(type => window.removeEventListener(type, stop, true));
      };
      const align = () => {
        if (!active || !target.isConnected) return;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          if (active && target.isConnected) target.scrollIntoView({block: 'start', behavior: 'instant'});
        });
      };
      events.forEach(type => window.addEventListener(type, stop, {capture: true, passive: true}));
      if (typeof ResizeObserver === 'function') {
        observer = new ResizeObserver(align);
        observer.observe(document.body);
      }
      window.addEventListener('load', align, {once: true});
      timer = setTimeout(stop, 5000);
      align();
    }
  }
  const selector = '.pw-page details[data-pw-make]';
  document.addEventListener('toggle', event => {
    const menu = event.target;
    if (!menu.matches?.(selector) || !menu.open) return;
    document.querySelectorAll(selector + '[open]').forEach(other => {
      if (other !== menu) other.open = false;
    });
  }, true);
  document.addEventListener('click', event => {
    document.querySelectorAll(selector + '[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest?.(selector + '[open]');
    if (!menu) return;
    menu.open = false;
    menu.querySelector('summary').focus();
    event.preventDefault();
  });
})();
